import Modal from 'react-bootstrap/Modal';
import PrimaryButton from '../../components/button'
import CloseIcon from '@mui/icons-material/Close'
import SecondaryButton from '../button/SecondaryButton';
import './index.scss'

type Props = {
  show: boolean,
  hide: () => void,
  handleDelete?: () => void,
  text?: string,
  subText?: string,
  errorMessage?: string,
  isLoading?: boolean,
  actionLabel?: string,
}

function NoticeModal({ show, hide, handleDelete, text, subText, errorMessage, isLoading, actionLabel = 'Delete' }: Props) {

  return (
    <Modal 
      show={show} 
      onHide={hide} 
      size="lg"
      >
      <Modal.Body className='notice-modal-container'>
        <span className='error-message-text'>{errorMessage}</span>
        <div className='close-header-icon'>
          <div className='icon-ctn' onClick={hide}>
           <CloseIcon className='icon'/>
          </div>
        </div>
        <p className='notice-title'>{text}</p>
        <div className='notice-content-ctn'>
          <span>
            {subText}
          </span>
        </div>

        <div className='notice-footer-btns'>
          <PrimaryButton disabled={isLoading} label={actionLabel} onClick={handleDelete} className="delete-btn"/>
          <div className='cancel-btn'>
            <span onClick={hide}>Cancel</span>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default NoticeModal;